
import AccessEmailUpsell from '~/components/modal/AccessEmailUpsell';
import GenericUpsell from '~/components/modal/GenericUpsell';
import Share from '~/components/modal/Share';
import Embed from '~/components/modal/Embed';
import ProductHuntSkip from '~/components/modal/ProductHuntSkip';
import InstagramVideo from '~/components/modal/InstagramVideo';
import TiktokVideo from '~/components/modal/TiktokVideo';
import TagsEditorModal from '~/components/campaign/tags/TagsEditorModal';

export default {
    name: 'ModalContainer',
    components: {
        AccessEmailUpsell,
        Share,
        Embed,
        InstagramVideo,
        TiktokVideo,
        ProductHuntSkip,
        GenericUpsell,
        TagsEditorModal,
    },
    data() {
        return {
            onCloseHandler: null,
        };
    },
    watch: {
        isModalOpen() {
            if (this.isModalOpen) {
                document.addEventListener('keydown', this.closeModalIfEscPressed);
            } else {
                document.removeEventListener('keydown', this.closeModalIfEscPressed);
            }
        },
    },
    computed: {
        isModalOpen() {
            const modalContent = this.$store.getters['ui/getModal'];
            if (!modalContent) {
                return false;
            }
            return modalContent.show && modalContent.component !== null;
        },
        isDefaultStyle() {
            return this.$store.getters['ui/getModal'].style === 'default';
        },
        componentName() {
            return this.$store.getters['ui/getModal'].component;
        },
        componentProps() {
            return {
                ...this.$store.getters['ui/getModal'].props,
                onCloseHandler: (onClose) => {
                    this.onCloseHandler = onClose;
                },
            };
        },
        isLarge() {
            return this.$store.getters['ui/getModal'].size === 'large';
        },
    },
    methods: {
        closeModalIfEscPressed(event) {
            if (event.key === 'Escape') {
                this.closeModal();
                document.removeEventListener('keydown', this.closeModalIfEscPressed);
            }
        },
        closeModal() {
            this.$store.commit('ui/hideModal');
            if (this.onCloseHandler) {
                this.onCloseHandler();
                this.onCloseHandler = null;
            }
        },
        closeModalFromBackground() {
            if (!this.isDefaultStyle) {
                return;
            }
            this.closeModal();
        },
    },
};
